import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { throttle, debounce } from "throttle-debounce";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "../../_common/Table";
import contractorActions from "../../../_actions/contractorActions";
import "../styles/adminStyles.css";
import "./adminContractors.css";
import EditContractorModal from "./EditContractorModal";
import AdminContractorDetails from "./AdminContractorDetails";
import { CONTRACTOR } from "../../../_constants/actionConstants";
import AdminContractorsDetailsModal from "./AdminContractorsDetailsModal";
import EditContractorModalV2 from "./EditContractorModalV2";

export class AdminContractors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nameFilter: "",
      sortColumn: { path: "name", order: "asc" },
      selectedContractor: null,
      showEditContractorModal: false,
      showContractorDetailsModal: false,
      isNew: false,
      currPage: 1,
      pageCount: 1,
    };

    this.columns = [
      {
        path: "name",
        label: "Contractor Name",
        thClassName: "admin-contractors-table__th--name",
        tdClassName: "admin-contractors-table__th--name",
      },
      {
        path: "abbreviation",
        label: "Abbrev.",
        thClassName: "admin-contractors-table__th--abbrev",
        tdClassName: "admin-contractors-table__th--abbrev",
      },
      {
        path: "edit",
        label: "",
        content: (contractor) => (
          <button
            type="button"
            name="editContractor"
            id={`editContractor_${contractor.contractorId}`}
            className="btn btn-sm btn-secondary"
            onClick={this.handleClick_editFromRow(contractor)}
            onTouchEnd={this.handleClick_editFromRow(contractor)}
            disabled={this.props.fetching}
          >
            Edit...
            {this.props.fetching &&
              this.state.selectedContractor &&
              this.state.selectedContractor.contractorId === contractor.contractorId && (
                <FontAwesomeIcon
                  icon="spinner"
                  className="fa-fw ml-1"
                  spin={this.props.fetching}
                />
              )}
          </button>
        ),
        thClassName: "admin-contractors-table__th--edit",
        tdClassName: "admin-contractors-table__th--edit",
        disableSort: true,
      },
      {
        path: "details",
        label: "",
        content: (contractor) => (
          <button
            type="button"
            name="contractorDetails"
            id={`contractorDetails_${contractor.contractorId}`}
            className="btn btn-sm btn-info"
            onClick={this.handleClick_detailsFromRow(contractor)}
            onTouchEnd={this.handleClick_detailsFromRow(contractor)}
            disabled={this.props.fetching}
          >
            Details
            {this.props.fetching &&
              this.state.selectedContractor &&
              this.state.selectedContractor.contractorId === contractor.contractorId && (
                <FontAwesomeIcon
                  icon="spinner"
                  className="fa-fw ml-1"
                  spin={this.props.fetching}
                />
              )}
          </button>
        ),
        thClassName: "admin-contractors-table__th--details",
        tdClassName: "admin-contractors-table__th--details",
        disableSort: true,
      },
    ];

    this.searchThrottled = throttle(250, this.handleSearch);
    this.searchDebounced = debounce(250, this.handleSearch);
  }

  async componentDidMount() {
    const { dispatch, tabId } = this.props;

    dispatch({ type: CONTRACTOR.SET_SEARCH_WAITINGFOR, tabId, waitingFor: "" });
    const pageCount = await dispatch(contractorActions.getPaged(tabId, 1, 50, "", true));
    this.setState({ pageCount });
  }

  // Clean up redux state
  componentWillUnmount() {
    const { dispatch, tabId } = this.props;
    dispatch({ type: CONTRACTOR.CLEAR_MISC_SESSION_DATA, tabId });
    dispatch({ type: CONTRACTOR.CLEAR_LIST, tabId });
    dispatch({ type: CONTRACTOR.CLEAR_ALL_DETAILS });
  }

  refreshList = async () => {
    const { dispatch, tabId } = this.props;
    const { nameFilter, selectedContractor } = this.state;

    // Since the list is being re-fetched with existing nameFilter,
    // there is no need to dispatch SET_WAITINGFOR (it's already been set when
    // the filter input was updated.)
    const resetList = true;
    const pageCount = await dispatch(
      contractorActions.getPaged(tabId, 1, 50, nameFilter, resetList)
    );

    if (selectedContractor)
      // Refetch details
      dispatch(contractorActions.getDetails(selectedContractor.contractorId));

    this.setState({ currPage: 1, pageCount });
  };

  clearDetails = () => {
    const { selectedContractor } = this.state;
    if (selectedContractor)
      dispatch({
        type: CONTRACTOR.CLEAR_DETAILS,
        contractorId: selectedContractor.contractorId,
      });

    this.setState({ selectedContractor: null });
  };

  /**
   * To be called only by the throttler/debouncer. SET_WAITINGFOR has already been dispatched
   * prior to this function.
   */
  handleSearch = async () => {
    const { dispatch, tabId } = this.props;
    const { nameFilter } = this.state;
    const pageCount = await dispatch(
      contractorActions.getPaged(tabId, 1, 50, nameFilter, true)
    );

    // There is only 1 page for search results.
    this.setState({ pageCount, currPage: 1 });
  };

  getNextPage = async () => {
    const { nameFilter, currPage } = this.state;
    const { dispatch, tabId } = this.props;
    const pageCount = await dispatch(
      contractorActions.getPaged(tabId, currPage + 1, 50, nameFilter, false)
    );
    this.setState({ currPage: currPage + 1, pageCount });
  };

  getDetailsAwait = async (contractorId) => {
    const { dispatch } = this.props;
    await dispatch(contractorActions.getDetails(contractorId));
  };

  handleSort = (sortColumn) => this.setState({ sortColumn });

  handleClick_editFromRow = (contractor) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isNew: false, selectedContractor: contractor }, async () => {
      await this.getDetailsAwait(contractor.contractorId);
      this.toggleEditContractorModal();
    });
  };

  handleClick_detailsFromRow = (contractor) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isNew: false, selectedContractor: contractor }, async () => {
      await this.getDetailsAwait(contractor.contractorId);
      this.toggleContractorDetailsModal();
    });
  };

  handleChange_nameFilter = (e) =>
    this.setState({ nameFilter: e.target.value }, async () => {
      const { nameFilter } = this.state;
      const { dispatch, tabId } = this.props;

      let pageCount = 1;
      dispatch({
        type: CONTRACTOR.SET_SEARCH_WAITINGFOR,
        tabId,
        waitingFor: nameFilter,
      });

      if (!nameFilter) {
        pageCount = await dispatch(contractorActions.getPaged(tabId, 1, 50, "", true));
        this.setState({ currPage: 1, pageCount });
      } else if (nameFilter.length < 3) this.searchThrottled();
      else this.searchDebounced();
    });

  handleClick_tr = async (contractor) => {
    const { selectedContractor } = this.state;
    const { dispatch } = this.props;

    // Do not await fetchDetails; show selectedContractor in the table first, then
    // show spinner until details are fetched and available in redux store.
    const mustReloadDetails =
      !selectedContractor || selectedContractor.contractorId !== contractor.contractorId;
    this.setState(
      { selectedContractor: contractor },
      () =>
        mustReloadDetails &&
        dispatch(contractorActions.getDetails(contractor.contractorId))
    );
  };

  handleClick_refresh = (e) => {
    e.preventDefault();
    this.refreshList();
    this.clearDetails();
  };

  handleClick_add = (e) => {
    e.preventDefault();
    this.setState({ isNew: true }, this.toggleEditContractorModal);
  };

  deleteContractor = async (contractor) => {
    const { dispatch } = this.props;
    await dispatch(contractorActions.deleteContractor(contractor.contractorId));
    this.refreshList();
    this.clearDetails();
  };

  handleClick_edit = (e) => {
    e.preventDefault();
    this.setState({ isNew: false }, this.toggleEditContractorModal);
  };

  toggleEditContractorModal = () =>
    this.setState({ showEditContractorModal: !this.state.showEditContractorModal });

  toggleContractorDetailsModal = () =>
    this.setState({ showContractorDetailsModal: !this.state.showContractorDetailsModal });

  renderTableFilters = () => {
    const { nameFilter } = this.state;
    return (
      <div className="d-flex flex-row flex-wrap w-100 mb-1 admin-filter-group">
        <div className="admin-filter-item admin-filter-item__input flex-grow-1">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="nameFilter"
              id="nameFilter"
              className="form-control"
              value={nameFilter}
              onChange={this.handleChange_nameFilter}
              placeholder="Contractor Name"
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      sortColumn,
      showEditContractorModal,
      selectedContractor,
      isNew,
      currPage,
      pageCount,
      showContractorDetailsModal,
    } = this.state;
    const { contractorList, tabId, permissions } = this.props;

    return (
      <React.Fragment>
        <h2 className="mb-1">Contractors</h2>
        <hr className="mt-0 mb-2" />
        <div className="d-flex flex-row w-100">
          <div className="admin-list pr-1">
            <div className="form-inline mb-2">
              <button
                type="button"
                name="refreshContractorData"
                id="refreshContractorData"
                className="btn btn-secondary mr-2"
                onClick={this.handleClick_refresh}
              >
                <FontAwesomeIcon icon="sync-alt" className="fa-fw mr-1" />
                Refresh
              </button>
              <button
                type="button"
                name="addContractor"
                id="addContractor"
                className="btn btn-info mr-2"
                onClick={this.handleClick_add}
              >
                <FontAwesomeIcon icon="plus" className="fa-fw mr-1" />
                New...
              </button>
            </div>
            {this.renderTableFilters()}
            <div className="d-flex flex-row w-100 mb-1">
              <div className="alert alert-warning p-2 w-100 mb-0">
                <h6>
                  <FontAwesomeIcon icon="exclamation-triangle" className="fa-fw mr-2" />
                  Updating Contractors
                </h6>
                <ul className="mb-0">
                  <li>Below list shows ALL contractors currently added to ProDMS.</li>
                  <li>
                    Changes made here may affect existing data, such as daily reports.
                  </li>
                  <li>
                    Contractors can be deleted only if it is unassigned from all
                    current/ongoing projects (go to Project Admin {`->`} Contractors).
                    Contractors cannot be deleted if it is assigned to any past/completed
                    project. You can view the past and ongoing projects for this
                    contractor in the details panel.
                  </li>
                </ul>
              </div>
            </div>
            <div className="admin-list__table--wrapper border">
              <Table
                className="table table-sm table-hover admin-list__table"
                data={contractorList || []}
                idPropName="contractorId"
                selectedItemId={selectedContractor && selectedContractor.contractorId}
                columns={this.columns}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleClick_tr}
                isPaginated={true}
                currPage={currPage}
                pageCount={pageCount}
                getNextPage={this.getNextPage}
              />
            </div>
          </div>
          <div className="admin-details">
            <div className="card">
              <div className="card-header bg-lightgray">Selected Contractor</div>
              <div className="card-body">
                <AdminContractorDetails
                  permissions={permissions}
                  contractorId={selectedContractor && selectedContractor.contractorId}
                  handleClick_edit={this.handleClick_edit}
                  deleteContractor={this.deleteContractor}
                />
              </div>
            </div>
          </div>
        </div>
        {showEditContractorModal && (
          <EditContractorModalV2
            showModal={showEditContractorModal}
            toggleModal={this.toggleEditContractorModal}
            data={{ isNew, contractorId: isNew ? null : selectedContractor.contractorId }}
            projectId={null}
            contractorId={isNew ? null : selectedContractor.contractorId}
            listRefreshCallback={this.refreshList} // No searchString argument is needed, since nameFilter is available here
          />
        )}
        {showContractorDetailsModal && (
          <AdminContractorsDetailsModal
            permissions={permissions}
            contractorId={selectedContractor && selectedContractor.contractorId}
            handleClick_edit={this.handleClick_edit}
            deleteContractor={this.deleteContractor}
            showContractorDetailsModal={showContractorDetailsModal}
            toggleContractorDetailsModal={this.toggleContractorDetailsModal}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  fetching: state.contractors.fetching,
  appSettings: state.appSettings,
  user: state.authentication.user,
  contractorList: state.contractors.contractorList[ownProps.tabId] || null,
});

export default connect(mapStateToProps)(AdminContractors);
